var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"grey--text",attrs:{"color":_vm.color,"app":""}},[_c('span',{staticClass:"wgu-footer-left",domProps:{"innerHTML":_vm._s(_vm.footerTextLeft)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"wgu-footer-right"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.footerTextRight)}}),_vm._v(" "),(_vm.showCopyrightYear)?_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear()))]):_vm._e()])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a0adb81","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/AppFooter.vue
// module id = CrNA
// module chunks = 1